import { formatDate } from 'lib/dateDisplay';
import { func, number, string } from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-flexbox-grid';

const RehabHeader = ({ fm, rehab, date }) => {
  return (
    <Row>
      <Col xs={6}>
        <h2>{fm('npView.views.rehabSession', { n: rehab })}</h2>
      </Col>
      {date && (
        <Col xs={6} style={{ paddingRight: '1rem' }}>
          <Row end="xs">
            <Col>
              {fm('npView.finishedDate')}
              {`: `}
              <span>{formatDate(date)}</span>
            </Col>
          </Row>
        </Col>
      )}
    </Row>
  );
};

RehabHeader.propTypes = {
  fm: func,
  rehab: number,
  date: string,
};
export default RehabHeader;
